import { useEffect, useState } from "react";
import api, { errMsg } from "@/lib/api";

/** Every active vehicle priced for the current route, off Google's driving miles. */
export function useVehiclePrices({ companyId, pickup, dropoff, stops = [], hours = 0,
                                   pricingMode = null, meetGreet = false, email = "" }) {
  const [prices, setPrices] = useState({});
  const [policy, setPolicy] = useState(null);
  const [miles, setMiles] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const addresses = (stops || []).filter((s) => s?.address);
  const key = JSON.stringify([companyId, pickup?.address, dropoff?.address,
    addresses.map((s) => s.address), hours, pricingMode, meetGreet, email]);

  useEffect(() => {
    if (!companyId || !pickup?.address || !dropoff?.address) {
      setPrices({});
      return undefined;
    }
    let dead = false;
    setLoading(true);
    setError("");
    // Debounced: an address autocomplete fires several times before the passenger stops typing.
    const timer = setTimeout(() => {
      api.post(`/public/company/${companyId}/quotes`, {
        pickup, dropoff, stops: addresses, hours: Number(hours || 0),
        pricing_mode: pricingMode || null, meet_greet: !!meetGreet, customer_email: email || "",
      }).then(({ data }) => {
        if (dead) return;
        const map = {};
        (data.vehicles || []).forEach((row) => { map[row.vehicle_id] = row.quote; });
        setPrices(map);
        setPolicy(data.policy || null);
        setMiles(data.miles ?? null);
      }).catch((e) => { if (!dead) setError(errMsg(e)); })
        .finally(() => { if (!dead) setLoading(false); });
    }, 500);
    return () => { dead = true; clearTimeout(timer); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  return { prices, policy, miles, loading, error };
}
